import styled from 'styled-components';
import Chip from '../../Chip';
import Icon from '../../Icon';
export var StyledTab = styled.button.withConfig({
  displayName: "Tabstyles__StyledTab",
  componentId: "sc-15v7v4i-0"
})(["background:transparent;border:none;position:relative;padding:0 var(--dentsu-spacing-20) var(--dentsu-spacing-16);margin:0 0 var(--dentsu-spacing-40);text-align:left;&::after{content:'';position:absolute;width:100%;height:1px;bottom:-1px;left:0;background:var(--dentsu-color-n300);border-radius:3px;transition:all var(--dentsu-motion-duration-moderate) ease;}&:focus{outline:none;}&:disabled{opacity:0.4;}&:hover:not(:disabled),&:focus{&::after{background:var(--dentsu-color-f500);}}&[aria-selected='true']{&::after{background:var(--dentsu-color-f500);height:3px;bottom:-2px;}}"]);
export var StyledTabTitle = styled.span.withConfig({
  displayName: "Tabstyles__StyledTabTitle",
  componentId: "sc-15v7v4i-1"
})(["display:block;"]);
export var StyledTabLabel = styled.span.withConfig({
  displayName: "Tabstyles__StyledTabLabel",
  componentId: "sc-15v7v4i-2"
})(["color:var(--dentsu-color-n975);font-size:var(--dentsu-font-size-16);font-weight:", ";line-height:var(--dentsu-leading-tight);"], function (props) {
  return props.isSelected ? 'var(--dentsu-font-weight-bold)' : 'var(--dentsu-font-weight-regular)';
});
export var StyledTabCount = styled.small.withConfig({
  displayName: "Tabstyles__StyledTabCount",
  componentId: "sc-15v7v4i-3"
})(["color:var(--dentsu-color-n975);font-size:var(--dentsu-font-size-14);font-weight:var(--dentsu-font-weight-light);line-height:var(--dentsu-leading-tight);display:inline-block;margin-left:var(--dentsu-spacing-8);"]);
export var StyledTabAssistive = styled.em.withConfig({
  displayName: "Tabstyles__StyledTabAssistive",
  componentId: "sc-15v7v4i-4"
})(["color:var(--dentsu-color-n700);font-size:var(--dentsu-font-size-14);font-weight:var(--dentsu-font-weight-regular);font-style:var(--dentsu-font-style-italic);line-height:var(--dentsu-leading-normal);display:block;margin-top:var(--dentsu-spacing-4);padding-left:", ";"], function (props) {
  return props.icon ? 'var(--dentsu-spacing-20)' : '0';
});
export var StyledTabIcon = styled(Icon).withConfig({
  displayName: "Tabstyles__StyledTabIcon",
  componentId: "sc-15v7v4i-5"
})(["margin-right:var(--dentsu-spacing-8);position:relative;top:-1px;vertical-align:middle;"]);
export var StyledTabChip = styled(Chip).withConfig({
  displayName: "Tabstyles__StyledTabChip",
  componentId: "sc-15v7v4i-6"
})(["margin:0 0 0 var(--dentsu-spacing-8);position:relative;top:-1px;vertical-align:middle;"]);